export function AutoRegisteredBadge({
  title = 'Auto-registered on first heartbeat — add it to the seed block to set a real display name and interval',
}: {
  title?: string;
}) {
  return (
    <span
      title={title}
      className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-medium bg-amber-100 text-amber-700 border border-amber-200"
    >
      auto
    </span>
  );
}
